export default function AnimatedBackground() {
  return (
    <div className="animated-bg" aria-hidden="true">
      <div className="cube" />
      <div className="cube" />
      <div className="cube" />
      <div className="cube" />
      <div className="cube" />
      <div className="cube" />
      <div className="cube" />
      <div className="cube" />
      <div className="orb" />
      <div className="orb" />
    </div>
  );
}
